const data = {
  id: 1,
  title: 'Fill the suitable word in the blank.',
  subTitle: 'Điền từ thích hợp vào chỗ trống',
  question: 'My ___ are collecting stamps and playing board games.',
  answers: [
    { id: 1, answer: 'subjects', isCorrect: false },
    { id: 2, answer: 'hobbies', isCorrect: true },
    { id: 3, answer: 'sports', isCorrect: false },
  ],
  settings: {
    answers: {
      // direction: 'horizontal',
      direction: 'vertical',
    },
  },
};

export default data;
